import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import ReactGA from 'react-ga';
import { signUp } from '../../constants/api';
import Yup from 'yup';
import { Btn, StyledField, StyledErrorField } from './survey.css';
import axios from 'axios';
import { Consumer } from 'store/createContext';

const SignUpInput = ({ delayReq }) => {
  return (
    <Consumer>
      {({ howSoon, salesMethod, userId, setUserEmail, goFwd }) => (
        <Formik
          initialValues={{ email: '' }}
          onSubmit={async values => {
            if (delayReq) {
              setUserEmail(values.email);
              return goFwd();
            }

            const result = await axios.post(signUp('dev'), {
              howSoon,
              salesMethod,
              userId,
              email: values.email,
            });

            if (result.status === 200) {
              this.setState({
                submitted: true,
              });

              ReactGA.event({
                category: 'Sign Up Flow',
                action: 'Submitted',
              });
            }
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email()
              .required('Required'),
          })}
          render={({ isSubmitting }) => (
            <Form>
              <StyledField
                type="email"
                name="email"
                placeholder="Enter Your Email"
              />
              <StyledErrorField name="email" />
              <Btn type="submit" disable={isSubmitting}>
                {isSubmitting ? 'Submitting' : 'Sign Up'}
              </Btn>
            </Form>
          )}
        />
      )}
    </Consumer>
  );
};

SignUpInput.propTypes = {
  delayReq: PropTypes.bool.isRequired,
};

SignUpInput.defaultProps = {
  delayReq: false,
};

export default SignUpInput;
